// profile/actionTypes.js

const CHANGE_VALUE = '@@profile/CHANGE_VALUE';
const REQUEST_REGISTER = '@@profile/REQUEST_REGISTER';
const REGISTER_RESPONSE = '@@profile/REGISTER_RESPONSE';

const REQUEST_SAVE = '@@profile/REQUEST_SAVE';
const SAVE_RESPONSE = '@@profile/SAVE_RESPONSE';

const REQUEST_INDUSTRY_TYPES = '@@profile/REQUEST_INDUSTRY_TYPES';
const INDUSTRY_TYPES_RESPONSE = '@@profile/INDUSTRY_TYPE_RESPONSE';

const REQUEST_ACCOUNT_INFO = '@@profile/REQUEST_REQUESTED_ACCOUNT_INFO';
const ACCOUNT_INFO_RESPONSE = '@@profile/ACCOUNT_INFO_RESPONSE';

const HYDRATE_PROFILE = '@@profile/HYDRATE_PROFILE';

export default {
    CHANGE_VALUE,
    REQUEST_REGISTER,
    REGISTER_RESPONSE,
    REQUEST_SAVE,
    SAVE_RESPONSE,
    HYDRATE_PROFILE,
    REQUEST_INDUSTRY_TYPES,
    INDUSTRY_TYPES_RESPONSE,
    REQUEST_ACCOUNT_INFO,
    ACCOUNT_INFO_RESPONSE
};